import { RelatorioReceitaModel } from '@/models/contabil/receita/RelatorioReceitaModel';
import { integracaoContabilApi } from '@/api/IntegracaoContabilApi';

export default class ReceitaService {

    static gerarRelatorio(tipo: string, request: RelatorioReceitaModel) {
        return integracaoContabilApi.gerarRelatorioReceita(tipo, request);
    }
}